'use strict';

var jsxRuntime = require('react/jsx-runtime');
var icons_Icon = require('./Icon.js');
var svgs_medium_key_Dark = require('../svgs/medium/key/Dark.js');
require('react');
require('../_chunks/combineClasses-5P8GTQkg.js');
require('../_chunks/index-CIVOGJRG.js');
require('../_chunks/designTokens-CKP-YoT2.js');

const IconKeyDark = (iconProps) => jsxRuntime.jsx(svgs_medium_key_Dark, { ...icons_Icon.getSvgProps(iconProps) });

exports.IconKeyDark = IconKeyDark;
//# sourceMappingURL=IconKeyDark.js.map
